function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "computer_mouse",
  transform: "translate(0 0.003)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61896",
  "data-name": "Path 61896",
  d: "M39.733,38.891V53.7a8.674,8.674,0,0,0,17.327,0V38.891a8.674,8.674,0,0,0-17.327,0Zm-1.733,0A10.151,10.151,0,0,1,48.4,29a10.149,10.149,0,0,1,10.4,9.891V53.7a10.151,10.151,0,0,1-10.4,9.891A10.149,10.149,0,0,1,38,53.7Z",
  transform: "translate(-38 -29)",
  fill: "#00001f",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61897",
  "data-name": "Path 61897",
  d: "M49,36v4a1,1,0,0,0,2,0V36a1,1,0,0,0-2,0Z",
  transform: "translate(-39.604 -29)",
  fill: "#00001f",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61898",
  "data-name": "Path 61898",
  d: "M48.391,81.992l4.28-5.5a.663.663,0,0,1,1.1,0,1.21,1.21,0,0,1,0,1.414l-4.83,6.207a.663.663,0,0,1-1.1,0l-4.867-6.254a1.21,1.21,0,0,1,0-1.414.663.663,0,0,1,1.1,0Z",
  transform: "translate(-38 -36.406)",
  fill: "#00001f",
  fillRule: "evenodd"
}));

function SvgComputerMouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.8,
    height: 48.003,
    viewBox: "0 0 20.8 48.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerMouse);
export default __webpack_public_path__ + "static/media/computer_mouse.605f47d9.svg";
export { ForwardRef as ReactComponent };